module.exports = __webpack_public_path__ + "img/l_bg.f74b56bb.png";